import { useEffect } from 'react';
import { useHeaderTitle } from '../components/HeaderTitleContext';

interface SEOData {
  title?: string;
  description?: string;
  canonical?: string;
}

const useDocumentTitle = (seoData?: SEOData) => {
  const { headerTitle } = useHeaderTitle();
  const defaultTitle = 'Fatima Al Qadiri';

  useEffect(() => {
    const finalTitle = seoData?.title || headerTitle;
    
    // Only add " | Fatima Al Qadiri" if the title is different from the default
    if (finalTitle && finalTitle !== defaultTitle) {
      document.title = `${finalTitle} | ${defaultTitle}`;
    } else {
      document.title = defaultTitle;
    }

    // Handle meta description
    if (seoData?.description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', seoData.description);
      }
    }

    // Canonical URL, in case things start getting weird
    if (seoData?.canonical) {
      let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = seoData.canonical;
    }

    // Now for Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      const finalOGTitle = seoData?.title || headerTitle || defaultTitle;
      ogTitle.setAttribute('content', finalOGTitle);
    }

    if (seoData?.description) {
      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute('content', seoData.description);
      }
    }

    if (seoData?.canonical) {
      const ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) {
        ogUrl.setAttribute('content', seoData.canonical);
      }
    }
  }, [headerTitle, seoData]);
};

export default useDocumentTitle;